import { CategoryPresets } from './types';

export const TEXT_MATCHING_PRESETS: CategoryPresets = {
  Equities: {
    'Buy/Sell': [
      {
        standardValue: 'BUY',
        defaultVariations: [],
        placeholder: 'e.g., Buy, קנה, Purchase, B',
      },
      {
        standardValue: 'SELL',
        defaultVariations: [],
        placeholder: 'e.g., Sell, מכר, Sale, S',
      },
    ],
    'Settlement Account': [
      {
        standardValue: 'Transfer',
        defaultVariations: [],
        placeholder: 'e.g., Transfer, Move, Shift',
        isPredefined: true,
      },
    ],
  },
  'Funds & ETFs': {
    'Buy/Sell': [
      {
        standardValue: 'BUY',
        defaultVariations: [],
        placeholder: 'e.g., Buy, קנה, Purchase, B',
      },
      {
        standardValue: 'SELL',
        defaultVariations: [],
        placeholder: 'e.g., Sell, מכר, Sale, S',
      },
    ],
    'Settlement Account': [
      {
        standardValue: 'Transfer',
        defaultVariations: [],
        placeholder: 'e.g., Transfer, Move, Shift',
        isPredefined: true,
      },
    ],
  },
  'Fixed Income': {
    'Buy/Sell': [
      {
        standardValue: 'BUY',
        defaultVariations: [],
        placeholder: 'e.g., Buy, קנה, Purchase, B',
      },
      {
        standardValue: 'SELL',
        defaultVariations: [],
        placeholder: 'e.g., Sell, מכר, Sale, S',
      },
    ],
    'Settlement Account': [
      {
        standardValue: 'Transfer',
        defaultVariations: [],
        placeholder: 'e.g., Transfer, Move, Shift',
        isPredefined: true,
      },
    ],
  },
  'FX Spot Trades - Buy': {
    'Instrument Type': [
      {
        standardValue: 'FX Spot Trades',
        defaultVariations: [],
        placeholder: 'e.g., FX, Forex, Currency',
        isPredefined: true,
      },
    ],
    'Buy Currency': [],
    'Sell Currency': [],
  },
  'FX Spot Trades - Sell': {
    'Instrument Type': [
      {
        standardValue: 'FX Spot Trades',
        defaultVariations: [],
        placeholder: 'e.g., FX, Forex, Currency',
        isPredefined: true,
      },
    ],
    'Buy Currency': [],
    'Sell Currency': [],
  },
  'Deposits and Withdrawals': {
    'Instrument Type': [
      {
        standardValue: 'Cash',
        defaultVariations: [],
        placeholder: 'e.g., Cash, Money, Funds',
        isPredefined: true,
      },
    ],
    'Deposit/Withdraw': [
      {
        standardValue: 'Deposit',
        defaultVariations: [],
        placeholder: 'e.g., Deposit, הפקדה, Credit, In',
      },
      {
        standardValue: 'Withdraw',
        defaultVariations: [],
        placeholder: 'e.g., Withdraw, משיכה, Debit, Out',
      },
    ],
    Currency: [],
  },
  Transfer: {
    'Instrument Type': [
      {
        standardValue: 'Transfer',
        defaultVariations: [],
        placeholder: 'e.g., Transfer, Move, Shift',
        isPredefined: true,
      },
    ],
    Currency: [],
  },
  'Cash Adjustments': {
    'Instrument Type': [
      {
        standardValue: 'Cash Adjustments',
        defaultVariations: [],
        placeholder: 'e.g., Adjustment, Cash Adj, Fee',
        isPredefined: true,
      },
    ],
    Currency: [],
    'Fee Type': [],
    'Deduction/Rebate': [
      {
        standardValue: 'DEDUCTION',
        defaultVariations: [],
        placeholder: 'e.g., Deduction, ניכוי, Charge, Fee',
      },
      {
        standardValue: 'REBATE',
        defaultVariations: [],
        placeholder: 'e.g., Rebate, החזר, Refund, Credit',
      },
    ],
    'Settlement Account': [
      {
        standardValue: 'Transfer',
        defaultVariations: [],
        placeholder: 'e.g., Transfer, Move, Shift',
        isPredefined: true,
      },
    ],
  },
};

export const shouldUsePredefinedBlocks = (
  category?: string,
  fieldName?: string
): boolean => {
  if (!category || !fieldName) return false;
  return !!TEXT_MATCHING_PRESETS[category]?.[fieldName];
};

export const getPredefinedBlocks = (category?: string, fieldName?: string) => {
  if (!category || !fieldName) return [];
  return TEXT_MATCHING_PRESETS[category]?.[fieldName] || [];
};

export const isCurrencyField = (
  category?: string,
  fieldName?: string
): boolean => {
  if (!category || !fieldName) return false;

  // Check for FX Spot Trades currency fields
  if (
    category.includes('FX Spot Trades') &&
    (fieldName === 'Buy Currency' || fieldName === 'Sell Currency')
  ) {
    return true;
  }

  // Check for Currency field in other tabs
  if (
    fieldName === 'Currency' &&
    (category === 'Deposits and Withdrawals' ||
      category === 'Transfer' ||
      category === 'Cash Adjustments')
  ) {
    return true;
  }

  return false;
};

export const isFeeTypeField = (
  category?: string,
  fieldName?: string
): boolean => {
  if (!category || !fieldName) return false;
  return category === 'Cash Adjustments' && fieldName === 'Fee Type';
};
